<div style="display: flex; flex-direction: column; width: 100%; height: 100%; min-height: 0;">

    <!-- Initial Load with Subsystem -->
    <div *ngIf="isLoadingSubby || isLoading"
        style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
        
            <sh-tabs id="errors-tabs-1" style="width: 43%" condensed [collapsed]="screenSize === 'XSmall' || screenSize === 'Small' || screenSize === 'Medium'"
                *ngIf="selectedWidget === 'instrument' || selectedWidget === 'service-history'">
                <sh-tab-item id="errors-tab-item-2" *ngFor="let tab of displayedTabs" disabled [active]="activeTab === tab.name"
                    (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
            </sh-tabs>
        
        <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
            <sh-spinner id="errors-spinner-3" site="s"></sh-spinner>
        </div>
    </div>

    <sh-tooltip id="errors-tooltip-4" #tooltip></sh-tooltip>

    <div style="flex: 1; min-height: 0px; display: flex; flex-direction: column; gap: 8px; height: 100%">

        <!-- Subsystem Table -->
        <div *ngIf="!isLoadingSubby && selectedSubsystem === null && subsystemdata" style="flex: 1; min-height: 0;">
            <p-table [size]="'small'" #table [value]="subsystemdata" [scrollable]="true" scrollHeight="flex"
                [customSort]="true" (sortFunction)="customSort($event)" [sortField]="'errors'" [sortOrder]="-1">

                <!-- Tools -->
                <ng-template #caption style="border: none; height: 100%">
                    <div style="display: flex; align-items: center; gap: 64px;">
                        <sh-tabs id="errors-tabs-5" style="flex: 1 1 43%;" condensed [collapsed]="screenSize === 'XSmall' || screenSize === 'Small' || screenSize === 'Medium'"
                            *ngIf="selectedWidget === 'instrument' || selectedWidget === 'service-history'">
                            <sh-tab-item id="errors-tab-item-6" *ngFor="let tab of displayedTabs" [active]="activeTab === tab.name"
                                (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
                        </sh-tabs>

                        <div class="table-tools" style="flex: 1 1 57%; gap: 8px; align-items: center;">
                            <sh-dropdown id="errors-dropdown-7" no-border condensed style="min-width: 100px; max-width: 140px;" [attr.value]="(selectedRange === 7 ? 'errors.range.7days' : selectedRange === 14 ? 'errors.range.14days' : 'errors.range.30days') | transloco">
                                <sh-menu-item id="errors-menu-item-7-days" (click)="changeRange(7,'systemHealth')" [attr.label]="'errors.range.7days' | transloco"
                                    [active]="selectedRange === 7"></sh-menu-item>
                                <sh-menu-item id="errors-menu-item-14-days" (click)="changeRange(14,'systemHealth')" [attr.label]="'errors.range.14days' | transloco"
                                    [active]="selectedRange === 14"></sh-menu-item>
                                <sh-menu-item id="errors-menu-item-30-days" (click)="changeRange(30,'systemHealth')" [attr.label]="'errors.range.30days' | transloco"
                                    [active]="selectedRange === 30"></sh-menu-item>
                            </sh-dropdown>
                            
                            <p-columnFilter style="min-width: 150px;" type="text" [showMenu]="false" field="subsystem"
                                matchMode="contains">
                                <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                                    <sh-search id="errors-search-search-for-subsystem" no-border [attr.label]="'errors.filter.searchForSubsystem' | transloco" condensed [(ngModel)]="searchTerm"
                                        (ngModelChange)="filter($event)"></sh-search>
                                </ng-template>
                            </p-columnFilter>
                            <!-- <sh-icon icon="menu" id="menu" button></sh-icon>
                            <sh-popover id="errors-popover-12" target="menu" placement="bottom">
                                <sh-menu-item id="errors-menu-item-event-logs"  label="Event Logs" color="secondary" clickable (click)="viewEventLogs()"></sh-menu-item>
                                <sh-menu-item id="errors-menu-item-all-charts" layout="compact"  color="secondary"
                                label="All Charts" (click)="openCharts()"></sh-menu-item>
                            </sh-popover> -->
                            <sh-divider id="errors-divider-15" spacing='s' style="height: 30px;" vertical></sh-divider>
                            <!-- <sh-button id="errors-button-event-logs" size="auto" label="Event Logs" color="secondary" (click)="viewEventLogs()"></sh-button>
                            

                            <sh-button id="errors-button-all-charts" layout="compact" icon="analytics" icon-position="left" color="secondary"
                                label="All Charts" (click)="openCharts()"></sh-button> -->

                            <sh-icon id="errors-icon-log" icon="log" size="s" (click)="viewEventLogs()" (mouseover)="showTooltip('errors.tooltip.eventLogs', $event)" button></sh-icon>
                            <sh-icon id="errors-icon-analytics" icon="analytics" size="s" (click)="openCharts()" (mouseover)="showTooltip('errors.tooltip.allCharts', $event)" button></sh-icon>
                            <sh-divider id="errors-divider-20" spacing='s' style="height: 30px;" vertical></sh-divider>

                            <sh-icon id="errors-icon-21" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
                            <sh-icon id="errors-icon-22" size="xs" *ngIf="workareaSize !== 'fullscreen'"
                                [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'" button
                                (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                            <sh-icon id="errors-icon-expand" size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"
                            [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                            <sh-icon id="errors-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
                                [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                        </div>
                    </div>
                </ng-template>

                <ng-template #header>
                    <tr>
                        <th pSortableColumn="name" style="min-width:175px;">
                            <div style="display: flex; align-items: center; gap: 6px;">{{ 'errors.table.subsystem' | transloco }}<p-sortIcon
                                    field="name" />
                            </div>
                        </th>
                        <th *ngIf="anomaliesEnabled" pSortableColumn="anomalies" style="min-width:175px;">
                            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">{{ 'errors.table.anomaliesAndTrend' | transloco }}
                                <sh-icon icon="confirmation" size="xs" style="cursor: help;"
                                    (click)="openHelp('Anomaly Detection'); $event.stopPropagation()"></sh-icon><p-sortIcon field="anomalies" /></div>
                        </th>
                        <th pSortableColumn="errors" style="min-width:175px;">
                            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">{{ 'errors.table.errorsAndTrend' | transloco }}
                                <p-sortIcon field="errors" /></div>
                        </th>
                        <th pSortableColumn="warnings" style="min-width:125px;">
                            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">
                                {{ 'errors.table.warnings' | transloco }}<p-sortIcon field="warnings" /></div>
                        </th>
                        <th style="min-width: auto; text-align: right;" pFrozenColumn alignFrozen="right">

                        </th>
                    </tr>
                </ng-template>
                <ng-template #body let-sub let-expanded="expanded">
                    <tr>
                        <td>
                            <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
                                <span [innerHTML]="highlight(sub.subsystem)"></span>
                            </div>
                        </td>
                        <td *ngIf="anomaliesEnabled">
                            <div *ngIf='getSubsystemAnomalyCount(sub) > 0'
                                style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
                                <canvas *ngIf="hasNonZeroTrend(getSubsystemAnomalyTrend(sub))" baseChart class="tableChart" type="line"
                                    [data]="anomalyChartConfigs[sub.subsystem]?.data"
                                    [options]="anomalyChartConfigs[sub.subsystem]?.options">
                                </canvas>
                                <div class="anomaly-pill">
                                    <span class="anomaly-pill__icon" aria-hidden="true">!</span>
                                    <span class="anomaly-pill__count">{{ getSubsystemAnomalyCount(sub) }}</span>
                                </div>
                            </div>
                            <div *ngIf='getSubsystemAnomalyCount(sub) === 0'
                                style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
                                <span>-</span>
                            </div>
                        </td>
                        <td>
                            <div *ngIf='sub["metrics"]["time_windows"][""+selectedRange]["ErrorEvents"] > 0'
                                style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
                                <canvas *ngIf="hasNonZeroTrend(sub['metrics']['time_windows'][''+selectedRange]['Trend'])" baseChart class="tableChart" type="line"
                                    [data]="chartConfigs[sub.subsystem]?.data"
                                    [options]="chartConfigs[sub.subsystem]?.options">
                                </canvas>
                                <sh-badge id="errors-badge-true" type='warning' size="medium" show-label="true"
                                    [label]='sub["metrics"]["time_windows"][""+selectedRange]["ErrorEvents"]+""'></sh-badge>
                            </div>
                            <div *ngIf='sub["metrics"]["time_windows"][""+selectedRange]["ErrorEvents"] === 0'
                                style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
                                <span>-</span>
                            </div>
                        </td>
                        <td>
                            <div *ngIf='sub["metrics"]["time_windows"][""+selectedRange]["Warnings"] > 0'
                                style="display: flex; justify-content: flex-end; align-items: center;">
                                <sh-badge id="errors-badge-true" type='warning' size="medium" show-label="true"
                                    [label]='sub["metrics"]["time_windows"][""+selectedRange]["Warnings"]+""'
                                    style="background-color: var(--success-icon-color) !important"></sh-badge>
                            </div>
                            <div *ngIf='sub["metrics"]["time_windows"][""+selectedRange]["Warnings"] === 0'
                                style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
                                <span>-</span>
                            </div>
                        </td>
                        <td pFrozenColumn alignFrozen="right">
                            <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center;">
                                <sh-button id="errors-button-events-analysis" icon-position="left"
                                    [disabled]='sub["metrics"]["time_windows"][""+selectedRange]["Warnings"] === 0 && sub["metrics"]["time_windows"][""+selectedRange]["ErrorEvents"] === 0'
                                    size="max-content" compact color="secondary"
                                    (click)="selectSubsystem(sub.subsystem)" [attr.label]="'errors.button.eventsAnalysis' | transloco"></sh-button>
                                <sh-button id="errors-button-events-overview" icon-position="left"
                                    [disabled]='sub["metrics"]["time_windows"][""+selectedRange]["Warnings"] === 0 && sub["metrics"]["time_windows"][""+selectedRange]["ErrorEvents"] === 0'
                                    size="max-content" compact color="tertiary"
                                    (click)="selectSubsystemPowerBI(sub.subsystem)" [attr.label]="'errors.button.eventsOverview' | transloco"></sh-button>
                            </div>
                        </td>
                    </tr>

                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">
                            <div *ngIf="!isError"
                                style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                                <sh-icon id="errors-icon-warning" icon="warning" size="s"></sh-icon>
                                <span>{{ 'common.empty.noData' | transloco }}</span>
                            </div>
                            <div *ngIf="isError"
                                style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                                <sh-icon id="errors-icon-error" icon="error" size="s"></sh-icon>
                                <span>{{ 'common.empty.error' | transloco }}</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>

            </p-table>
        </div>


        <!-- Events Table -->
        <div *ngIf="!isLoading && !isError && !loadingService.$isSystemHealthEmpty.value && selectedSubsystem !== null"
            style="flex: 1; min-height: 0; height: 100%">
        <div class="table-wrapper" [ngClass]="workareaSize === 'fullscreen' ? 'pip': ''">
            

            <section class="table-section">
            <p-table #tabletwo [value]="errors" [virtualScroll]="true" [virtualScrollItemSize]="98"
                [scrollable]="true" [rows]="20" scrollHeight="flex" [customSort]="true"
                (sortFunction)="customSortEvents($event)" (onFilter)="onTableFiltered($event)" [sortField]="'timestamp'"
                [sortOrder]="1">

                <!-- Tools -->
                <ng-template #caption style="border: none; height: 100%">
                    <div style="display: flex; align-items: center; gap: 64px;">
                        <sh-tabs id="errors-tabs-30" style="flex: 1 1 43%;" condensed [collapsed]="screenSize === 'XSmall' || screenSize === 'Small' || screenSize === 'Medium'"
                            *ngIf="selectedWidget === 'instrument' || selectedWidget === 'service-history'">
                            <sh-tab-item id="errors-tab-item-31" *ngFor="let tab of displayedTabs" [active]="activeTab === tab.name"
                                (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
                        </sh-tabs>

                        <div class="table-tools" style="flex: 1 1 57%; gap: 8px; align-items: center;">
                            <div *ngIf="screenSize === 'Large' || screenSize === 'XLarge'" id="disabledErrorDrodpown">
                                <sh-dropdown id="errors-dropdown-32" no-border condensed style="min-width: 120px; max-width: 140px;" disabled>
                                    <sh-menu-item id="errors-menu-item-last-7-days" [attr.label]="'errors.events.range.last7Days' | transloco" active></sh-menu-item>
                                </sh-dropdown>
                            </div>

                            <sh-tooltip *ngIf="screenSize === 'Large' || screenSize === 'XLarge'" id="errors-tooltip-error-events-are-fixed-to" [attr.label]="'errors.events.rangeTooltip.message' | transloco"
                                target="disabledErrorDrodpown" [attr.title]="'errors.events.rangeTooltip.title' | transloco" placement="top"
                                variation="long"></sh-tooltip>

                            <sh-dropdown no-border condensed [attr.label]="'errors.events.dropdown.eventTypes' | transloco" [multiSelect]="true"
                                display="label" class="event-type-dropdown">
                                <sh-menu-item *ngFor="let option of activeFilterOptions" [attr.label]="option.label | transloco"
                                    [active]="isScatterFilterSelected(option.key)"
                                    (click)="toggleScatterFilter(option.key)"></sh-menu-item>
                            </sh-dropdown>

                            <p-columnFilter style="flex: 1 1 150px; min-width: 100px;" type="text" [showMenu]="false" field="searchable"
                                matchMode="contains">
                                <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                                    <sh-search id="errors-search-search-for-event-or-messa" no-border [attr.label]="'errors.events.filter.label' | transloco" condensed
                                        [(ngModel)]="searchTermDetails" (ngModelChange)="filter($event)"></sh-search>
                                </ng-template>
                            </p-columnFilter>

                            <sh-divider id="errors-divider-36" spacing='s' style="height: 30px;" vertical></sh-divider>

                            <sh-button *ngIf="workareaSize === 'medium'" id="errors-button-back" icon="reset" icon-position="left" [attr.label]="'errors.events.button.back' | transloco" copact size="s"
                                color="primary-neutral" (click)="resetSubsystem()"></sh-button>
                            <sh-icon *ngIf="workareaSize !== 'medium'" icon="reset" size="s" button
                                (click)="resetSubsystem()"></sh-icon>

                            <sh-divider id="errors-divider-38" spacing='s' style="height: 30px;" vertical></sh-divider>

                            <sh-icon id="errors-icon-39" button icon='refresh' size="s" (click)="refreshEvents()"></sh-icon>
                            <sh-icon id="errors-icon-40" size="xs"
                                [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'" button
                                (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                            <sh-icon id="errors-icon-pip-1" size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"></sh-icon>
                            <sh-icon id="errors-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
                                [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                        </div>
                    </div>

                    <!-- Scatter Plot -->
                    <div *ngIf="!isLoading && !isError && errors && selectedSubsystem" style="height: 150px;">
                        <canvas #scatter baseChart type="scatter" [data]="chartConfig?.['data']"
                            [options]="chartConfig?.['options']" style="cursor: crosshair;"></canvas>
                        <div id="filters"
                            style="position: absolute; top: 60px; right: 0; display: flex; gap: 8px; background-color: var(--base-3);">
                            <sh-tag id="errors-tag-text-filter" *ngIf="searchTermDetails" [attr.label]="'errors.events.tag.textFilter' | transloco"></sh-tag>
                            <sh-tag id="errors-tag-date-filter-applied" *ngIf="isDateFiltered" [attr.label]="'errors.events.tag.dateFilter' | transloco"></sh-tag>
                        </div>
                    </div>
                </ng-template>

                <!-- Header -->
                <ng-template #header>
                    <tr>
                        <th column="3" pSortableColumn="code" style="min-width:175px;">
                            <div style="display: flex; align-items: center; gap: 6px;">{{ 'errors.events.table.eventCode' | transloco }}<p-sortIcon
                                    field="code" />
                            </div>
                        </th>
                        <th column="3" pSortableColumn="timestamp" style="min-width:175px;">
                            <div style="display: flex; align-items: center; gap: 6px;">{{ 'errors.events.table.timestamp' | transloco }}<p-sortIcon
                                    field="timestamp" />
                            </div>
                        </th>
                        <th  column="3" pSortableColumn="severity" style="min-width:175px;">
                            <div style="display: flex; align-items: center; gap: 6px;">{{ 'errors.events.table.severity' | transloco }}<p-sortIcon
                                    field="severity" />
                            </div>
                        </th>
                        <th column="6" pSortableColumn="message" style="min-width:600px;">
                            <div style="display: flex; align-items: center; gap: 6px;">{{ 'errors.events.table.messageText' | transloco }}<p-sortIcon
                                    field="message" />
                            </div>
                        </th>
                        <th column="6" pSortableColumn="data" style="min-width:600px;">
                            <div style="display: flex; align-items: center; gap: 6px;">{{ 'errors.events.table.eventData' | transloco }}<p-sortIcon
                                    field="data" />
                            </div>
                        </th>
                        <th column="3" pSortableColumn="sw" style="min-width:175px;">
                            <div style="display: flex; align-items: center; gap: 6px;">{{ 'errors.events.table.softwareVersion' | transloco }}<p-sortIcon
                                    field="sw" /></div>
                        </th>
                       

                        <th column="4" alignFrozen="right" style="min-width: 284px;" pFrozenColumn>{{ 'errors.events.table.actions' | transloco }}</th>
                    </tr>
                </ng-template>


                <ng-template #body let-error let-expanded="expanded">
                    <tr style="height:98px !important; overflow:hidden;">
                        <td class="cell-ellipsis">
                            <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
                                <span [innerHTML]="highlightDetails(error['EventCode'])"></span>
                            </div>
                        </td>
                        <td class="cell-ellipsis">
                            <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
                                <span [innerHTML]="error['BucketedTimestamp']"></span>
                            </div>
                        </td>
                        <td class="cell-ellipsis">
                            <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
                                <span [innerHTML]="error['Severity']"></span>
                            </div>
                        </td>
                        <td class="cell-ellipsis">
                            <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
                                <span [innerHTML]="highlightDetails(error['MessageText'])"></span>
                            </div>
                        </td>
                        <td class="cell-ellipsis">
                            <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
                                <span [innerHTML]="highlightDetails(error['Event Data'])"></span>
                            </div>
                        </td>
                        <td class="cell-ellipsis">
                            <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
                                <span [innerHTML]="error['Software Version']"></span>
                            </div>
                        </td>
                     
                        <td alignFrozen="right" pFrozenColumn>
                        <div style="display: flex; justify-content: flex-end; align-items: center; gap: 8px; width: 100%;">
                            <sh-button id="errors-button-ata" [attr.label]="'errors.events.button.ata' | transloco" color="tertiary" *ngIf="error['ata_link'] && !businessPartnerMode" (click)="goToATA(error['ata_link'])"></sh-button>

                            <sh-button id="errors-button-how-to-fix" icon-position="left" icon="ai-generative" [ngClass]="'magic-button'" compact
                                [attr.label]="'errors.events.button.howToFix' | transloco" size="m" color="tertiary"
                                (click)="askChat(error['EventCode'], error['Severity'])"></sh-button>
                        </div>
                            <!-- <div style="display: flex; gap: 8px; justify-content: flex-end; align-items: center;">
                            <sh-button id="errors-button-solve" *ngIf="error['metrics'][''+selectedRange]['failed'] > 0" layout="compact" color="tertiary" icon="ai-generative" icon-position="left"
                                label="Solve" size="s" (click)="askChat(error.name)"></sh-button>
                            <sh-button id="errors-button-charts" layout="compact" color="tertiary" label="Charts" (click)="openCharts()"></sh-button>
                        </div> -->
                        </td>
                    </tr>

                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">
                            <div *ngIf="!isError || loadingService.$isSubbyError.value"
                                style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                                <sh-icon id="errors-icon-warning" icon="warning" size="s"></sh-icon>
                                <span>{{ 'common.empty.noData' | transloco }}</span>
                            </div>
                            <div *ngIf="isError"
                                style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                                <sh-icon id="errors-icon-error" icon="error" size="s"></sh-icon>
                                <span>{{ 'common.empty.error' | transloco }}</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>

            </p-table>
            </section>
        </div>
        </div>

    </div>

</div>